// extracted by mini-css-extract-plugin
export default {"Panneau":"PanneauPrestation_Panneau__X29rx","BoutonTitre":"PanneauPrestation_BoutonTitre__Zi3Y3","Formulaire":"PanneauPrestation_Formulaire__7RSSP"};